import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setBuyer, setAuthenticated } from "../../../redux/slices/authSlice";
import "../../../styles/globals.scss";
import { OTP_TYPE, verifyOtp } from "./services/authServices";
import InputField from "../../../components/InputField";
import { showNotification } from "../../../redux/slices/notificationSlice";
import AuthCard from "../../../components/AuthCard";
import Button from "../../../components/Button";
import FormGroup from "../../../components/FormGroup";
import ErrorText from "../../../components/ErrorText";
import RequiredLabel from "../../../components/RequiredLabel";

export default function VerifyMobile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mobile = useSelector((state) => state.auth.mobile);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();
  const isOtpComplete = otp.length === 4;
  const requiredReason = t("pleaseCompleteRequiredFields", {
    defaultValue: "Please complete all required fields correctly.",
  });

  const handleVerify = async () => {
    if (!isOtpComplete || isSubmitting) return;
    setIsSubmitting(true);
    setError("");
    try {
      const { buyer, token } = await verifyOtp(`+61${mobile}`, OTP_TYPE.PHONE, otp);

      if (buyer && token) {
        localStorage.setItem("jwtToken", token);
        localStorage.setItem("buyer", JSON.stringify(buyer));
        dispatch(setBuyer(buyer));
        dispatch(setAuthenticated(true));
        dispatch(
          showNotification({ message: t('mobileVerified'), type: "success" })
        );
        navigate("/dashboard");
      } else {
        dispatch(
          showNotification({ message: t('mobileVerified'), type: "success" })
        );
        // No account exists yet; continue signup without requiring email
        navigate("/auth/add-username");
      }
    } catch {
      setError(t('invalidOrExpiredOtp'));
      dispatch(
        showNotification({ message: t('invalidOrExpiredOtp'), type: "error" })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <h2 className="main-header mb-4 text-center">{t("verifyOtp")}</h2>
        <p className="text-sm text-center mb-4">
          {t("enterOtpMobile")} +61 {mobile}
        </p>
        <FormGroup>
          <RequiredLabel htmlFor="mobile-otp" className="mb-2">
            {t("enterOtp")}
          </RequiredLabel>
          <InputField
            id="mobile-otp"
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
            maxLength={4}
            placeholder={t("enterOtp")}
            className="text-center"
            required
          />
        </FormGroup>
        {error && <ErrorText>{error}</ErrorText>}
        <Button
          className="w-full"
          onClick={handleVerify}
          disabled={!isOtpComplete || isSubmitting}
          disabledReason={!isOtpComplete ? requiredReason : ""}
          loading={isSubmitting}
          loadingLabel={t("loading")}
        >
          {t("verifyAndContinue")}
        </Button>
      </AuthCard>
    </div>
  );
}
